import React, { useState, useEffect, useCallback } from "react";
import SelectInput from "components/common/InputField/SelectInput";
import TextInput from "components/common/InputField/TextInput";
import TextareaInput from "components/common/InputField/TextareaInput";
import { displayFileIcon } from "helpers";
import { useAppDispatch, useAppSelector } from "hooks/storeHooks";
import { inventoryActions, vendorActions } from "redux/Ldb/actions";
import Loader from "components/common/Loader";
import { getFileTypeFromUrl } from "helpers/getFileTypeFromUrl";
import DateInput from "components/common/DateInput";
import { debounce } from "lodash";

const EditOfflinePurchase = ({
    stockDetails,
    handleStockDetailsChange,
    attachment,
    uploadingAttachment,
    handleUpload,
    handleDeleteAttachment,
    productDates,
    handleDateChange,
    setStockDetails,
    productName,
}: any): JSX.Element => {
    const dispatch = useAppDispatch();
    const [showExpirationDate, setShowExpirationDate] = useState<boolean>(false);
    const [showBBDate, setShowBBDate] = useState<boolean>(false);
    const [showRemovalTimeDate, setShowRemovalTimeDate] = useState<boolean>(false);
    const [showManufactureDate, setShowManufactureDate] = useState<boolean>(false);
    const [product, setProduct] = useState<{ [key: string]: any }>([]);
    const [productWarehouse, setProductWarehouse] = useState<{ [key: string]: any }>([]);
    const [inventory, setInventory] = useState<any>([]);
    const [warehouses, setWarehouses] = useState<any>();
    const [suppliers, setSuppliers] = useState<any>();
    const [debouncedSearch, setDebouncedSearch] = useState({
        search: "",
    });
    const { fetchedOnboardedVendorsSuccess } = useAppSelector((state) => state?.vendor);
    const {
        fetchingWarehouses,
        fetchedWarehousesSuccess,
        fetchingInventoryList,
        fetchedInventoryListSuccess,
    } = useAppSelector((state) => state?.inventory);

    useEffect(() => {
        if (Boolean(fetchedInventoryListSuccess)) {
            setInventory(fetchedInventoryListSuccess?.inventory?.data);
        }
    }, [fetchedInventoryListSuccess]);

    useEffect(() => {
        if (stockDetails?.inventoryId && inventory) {
            const copyInventory = [...inventory];
            const getProduct = copyInventory?.filter(
                (item) => item?._id === stockDetails?.inventoryId
            );
            setProduct(getProduct);
        }
    }, [inventory, stockDetails]);

    useEffect(() => {
        if (stockDetails?.warehouseId && warehouses) {
            const copyWarehouse = [...warehouses];
            const getWarehouse = copyWarehouse?.filter(
                (item) => item?._id === stockDetails?.warehouseId
            );
            setProductWarehouse(getWarehouse);
        }
    }, [warehouses, stockDetails]);

    useEffect(() => {
        if (Boolean(fetchedWarehousesSuccess)) {
            setWarehouses(fetchedWarehousesSuccess?.warehouses.data);
        }
    }, [fetchedWarehousesSuccess]);

    useEffect(() => {
        dispatch(inventoryActions.fetchInventoryList(20, 1, debouncedSearch.search));
    }, [dispatch, debouncedSearch.search]);

    useEffect(() => {
        dispatch(inventoryActions.fetchWarehouses(100));
    }, [dispatch]);

    useEffect(() => {
        if (Boolean(fetchedOnboardedVendorsSuccess)) {
            setSuppliers(fetchedOnboardedVendorsSuccess?.vendors);
        }
    }, [fetchedOnboardedVendorsSuccess]);

    useEffect(() => {
        dispatch(vendorActions.getOnboardedVendors());
    }, [dispatch]);


    return (
        <div className="w-[65%]">
            <div>
                <div className="">
                    <p className="pb-4 font-rocGroteskMedium text-gun-metal text-base">
                        Stock details
                    </p>
                    <div className="flex flex-col gap-6">
                       
                        <div className="grid grid-cols-2 items-center gap-4 ">
                            <SelectInput
                                value={stockDetails?.inventoryId?productName:""}
                                name="inventoryId"
                                placeholder={"Select product"}
                                isRequired={true}
                                handleInputChange={debounce((evt) => {
                                    setDebouncedSearch({
                                        search: evt.target.value,
                                    });
                                }, 800)}
                                disabled
                                searchLoading={false}
                                dropdownOptions={product?.map((item) => ({
                                    label: <div className="flex gap-2">{item?.productName}</div>,
                                    value: item?._id,
                                }))}
                            />
                            <SelectInput
                                value={stockDetails?.vendorId}
                                name="vendorId"
                                placeholder={"Select Supplier"}
                                handleChange={(name, value) => {
                                    handleStockDetailsChange({ target: { name, value } });
                                }}
                                // isRequired={true}
                                dropdownOptions={suppliers?.map((item) => ({
                                    label: item?.vendor?.profile?.businessName,
                                    value: item?.vendorId,
                                }))}
                                clearValue={true}
                            />
                            <div className="flex gap-1">
                                <div className="w-[160px]">
                                    <SelectInput
                                        value={stockDetails?.cost?.currency}
                                        name="currency"
                                        placeholder="Currency"
                                        handleChange={(name, value) => {
                                            handleStockDetailsChange({ target: { name, value } });
                                        }}
                                        isRequired={true}
                                        dropdownOptions={[
                                            {
                                                label: "GBP (£)",
                                                value: "GBP",
                                            },
                                            {
                                                label: "USD ($)",
                                                value: "USD",
                                            },
                                            {
                                                label: "EUR (€)",
                                                value: "EUR",
                                            },
                                            {
                                                label: "NGN (₦)",
                                                value: "NGN",
                                            },
                                        ]}
                                    />
                                </div>

                                <TextInput
                                    value={stockDetails?.cost?.amount}
                                    name={"amount"}
                                    type={"number"}
                                    onChange={handleStockDetailsChange}
                                    placeholder={"Unit cost"}
                                    containerClassname=""
                                    required
                                />
                            </div>

                            <div className="">
                                <TextInput
                                    value={stockDetails?.quantity}
                                    name={"quantity"}
                                    type={"number"}
                                    onChange={handleStockDetailsChange}
                                    placeholder={"Quantity"}
                                    containerClassname=""
                                    required
                                />
                            </div>
                        </div>
                        <SelectInput
                            value={stockDetails?.warehouseId}
                            name="warehouseId"
                            placeholder={"Warehouse"}
                            searchLoading={fetchingWarehouses}
                            dropdownOptions={productWarehouse?.map((item) => ({
                                label: item?.warehouseName,
                                value: item?._id,
                            }))}
                        />
                    </div>
                </div>

                <div className="mt-8">
                    <label className="text-base font-rocGroteskMedium mb-6">
                        Place this batch in quarantine?
                    </label>
                    <div className="flex gap-[52px] font-rocGroteskMedium text-base items-center">
                        <div
                            className="flex items-center gap-4"
                            onClick={() =>
                                setStockDetails((prev) => ({
                                    ...prev,
                                    quarantine: true,
                                }))
                            }
                        >
                            {stockDetails?.quarantine ? (
                                <i
                                    className={`ri-radio-button-fill text-xl cursor-pointer ${
                                        stockDetails?.quarantine && "text-y-10"
                                    }`}
                                ></i>
                            ) : (
                                <i className="ri-circle-line text-n-50 text-xl"></i>
                            )}
                            Yes
                        </div>
                        <div
                            className="flex items-center gap-4"
                            onClick={() =>
                                setStockDetails((prev) => ({
                                    ...prev,
                                    quarantine: false,
                                }))
                            }
                        >
                            {!stockDetails?.quarantine ? (
                                <i
                                    className={`ri-radio-button-fill text-xl cursor-pointer ${
                                        !stockDetails?.quarantine && "text-y-10"
                                    }`}
                                ></i>
                            ) : (
                                <i className="ri-circle-line text-n-50 text-xl"></i>
                            )}
                            No
                        </div>
                    </div>
                </div>

                <div className="">
                    <div className="flex flex-col gap-6 mt-8">
                        <div>
                            <label className="text-base font-rocGroteskMedium">
                                Product timeline
                            </label>
                        </div>
                        <div className="grid grid-cols-2 items-center gap-4 mt-4">
                            <DateInput
                                label="Manufacturing Date"
                                value={productDates?.manufacturingDate}
                                onChange={(newDate) =>
                                    handleDateChange("manufacturingDate", newDate)
                                }
                                showCalendar={showManufactureDate}
                                onCalendarToggle={setShowManufactureDate}
                            />
                            <DateInput
                                label="Expiration time"
                                value={productDates?.expiryDate}
                                onChange={(newDate) => handleDateChange("expiryDate", newDate)}
                                showCalendar={showExpirationDate}
                                onCalendarToggle={setShowExpirationDate}
                            />
                        </div>
                        {/* <div className="grid grid-cols-2 items-center gap-4 mt-2">
                            <DateInput
                                label="Best before time"
                                value={productDates?.bestBefore}
                                onChange={(newDate) => handleDateChange("bestBefore", newDate)}
                                showCalendar={showBBDate}
                                onCalendarToggle={setShowBBDate}
                            />
                            <DateInput
                                label="Removal time"
                                value={productDates?.removalTime}
                                onChange={(newDate) => handleDateChange("removalTime", newDate)}
                                showCalendar={showRemovalTimeDate}
                                onCalendarToggle={setShowRemovalTimeDate}
                            />
                        </div> */}

                        {
                            <div>
                                <label className="text-base font-rocGroteskMedium">
                                    Attachments
                                </label>
                                <input
                                    type="file"
                                    className="hidden"
                                    id="attachment"
                                    accept="image/*, .pdf, .xlsx"
                                    disabled={uploadingAttachment}
                                    onChange={(e) => {
                                        if (e.target.files?.[0]) {
                                            handleUpload(
                                                e.target.files?.[0]?.name as string,
                                                e.target.files?.[0]?.size as number
                                            );
                                        }
                                    }}
                                />
                                <div className="mt-4 ">
                                    {attachment?.map((item, idx) => {
                                        return (
                                            <div className="flex items-center justify-between p-3 rounded-md border border-slate-200 mb-4">
                                                <div className="flex items-center gap-2">
                                                    {/* {displayFileIcon("pdf", false)} */}
                                                    {displayFileIcon(
                                                        getFileTypeFromUrl(item?.path),
                                                        false
                                                    )}
                                                    <div className="font-rocGroteskMedium">
                                                        <p className="text-sm">{item?.filename}</p>
                                                        <p className="text-xs text-slate-500">
                                                            {/* {item?.size} */}
                                                        </p>
                                                    </div>
                                                </div>
                                                <i
                                                    className="ri-delete-bin-line text-xl text-r-50 cursor-pointer"
                                                    onClick={() =>
                                                        handleDeleteAttachment(idx, item?._id)
                                                    }
                                                ></i>
                                            </div>
                                        );
                                    })}

                                    <label
                                        className={`flex items-center gap-4 py-3 px-6 rounded border border-dashed border-slate-200  ${
                                            !uploadingAttachment && "cursor-pointer"
                                        }`}
                                        htmlFor="attachment"
                                    >
                                        <i className="ri-file-add-line text-2xl text-carribean-green"></i>
                                        {uploadingAttachment ? (
                                            <div className="">
                                                <Loader size={4} />
                                            </div>
                                        ) : (
                                            <p className="text-sm underline text-carribean-green font-rocGroteskMedium">
                                                Click to upload document
                                            </p>
                                        )}
                                    </label>
                                </div>
                            </div>
                        }
                        {stockDetails?.notes && (
                            <div>
                                <label className="text-base font-rocGroteskMedium">
                                    Addition Info
                                </label>
                                <div className="mt-4">
                                    <TextareaInput
                                        name={"notes"}
                                        value={stockDetails?.notes}
                                        onChange={handleStockDetailsChange}
                                        rows={5}
                                        placeholder={"Add note"}
                                        containerClassname=""
                                    />
                                </div>
                            </div>
                        )}
                        {stockDetails?.inspectionNote && (
                            <div>
                                <label className="text-base font-rocGroteskMedium">
                                    Inpection Note
                                </label>
                                <div className="mt-4">
                                    <TextareaInput
                                        name={"inspectionNote"}
                                        value={stockDetails?.inspectionNote}
                                        onChange={handleStockDetailsChange}
                                        rows={5}
                                        placeholder={"Add note"}
                                        containerClassname=""
                                    />
                                </div>
                            </div>
                        )}
                        {stockDetails?.conditionNote && (
                            <div>
                                <label className="text-base font-rocGroteskMedium">Condition</label>
                                <div className="mt-4">
                                    <TextareaInput
                                        name={"conditionNote"}
                                        value={stockDetails?.conditionNote}
                                        onChange={handleStockDetailsChange}
                                        rows={5}
                                        placeholder={"Add note"}
                                        containerClassname=""
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditOfflinePurchase;
